import loadable from '@loadable/component'

export const Paragraph = loadable(() => import('./Paragraph'))
export const ParagraphCollapsible = loadable(
  () => import('./ParagraphCollapsible')
)
export const Paragraphs = loadable(() => import('./Paragraphs'))
export type { ParagraphProps } from './Paragraph'
export type { ParagraphsProps } from './Paragraphs'
